import { DocumentoAllegato } from './documento-allegato';
import { SottoTipoTitoloEsecutivo } from './tipologiche/sotto-tipo-titolo-esecutivo';
import { TipoTitoloEsecutivo } from './tipologiche/tipo-titolo-esecutivo';

export class TitoloEsecutivo {
  id: string;
  tipoTitoloEsecutivo: TipoTitoloEsecutivo; // mandatory
  sottoTipoTitoloEsecutivo: SottoTipoTitoloEsecutivo; // mandatory
  documenti: DocumentoAllegato[];
  descrizione: string; // mandatory
  numero: number;
  anno: number;
  dataIscrizione: number;
  valore: number;
  note: string;
}
